<style type="text/css">
  .loadercenter {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .overlay {
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    /* background-color: black; */
    z-index: 99999;
  }

  div.item {
    vertical-align: top;
    display: inline-block;
    text-align: center;
    width: 120px;
  }
</style>
<div class="item" *ngIf="isShowLoader">
  <div class="overlay">
    <div class="loadercenter">
      <img src="{{assetURL}}/assets/images/GIF/loading.gif" width="64" height="64" alt="Loading..." />
    </div>
  </div>
</div>
<div *ngIf="!isShowLoader">
  <section class="section-wedding"
    style="background-image: url('{{assetURL}}/assets/images/{{categoryBackgroundImage}}');">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-auto">
          <h1 class="text-center text-white">{{categoryHeadName}} Invitation</h1>
          <p class="lead text-center text-white">
            Make a stunning digital {{categoryHeadName}} invitation card that will be
            remembered forever!
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="category-intro">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-auto">
          <h1 class="text-center">{{ pageTitle }}</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-auto moduleContainer" [class.show]="categoryData?.IsShowMore">
          <div [innerHTML]="categoryData?.CategoryDescription" class="text-center"></div>
        </div>
        <a role="button" class="btn-showcontent" (click)="changeContentVisibility(categoryData)">{{ categoryData?.IsShowMore ? 'Show less': 'Show
          More' }}</a>

      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-md-auto" *ngFor="let subCategory of subCategoryData; let i = index">
          <button class="btn-main-round" (click)="scrollToElement(i)">{{subCategory?.SubCategoryName}}
            invitation</button>
        </div>
      </div>
    </div>
  </section>
  <section class="cat-bg">
    <section class="all-videos section-divider" *ngIf="AllVideoData != null && AllVideoData?.length > 0">
      <div *ngFor="let subCategory of subCategoryData; let i = index" id="section{{i}}" class="my-5"
        [ngClass]="i % 2 == 0 ? 'cat-bg-gray' : 'cat-bg-white'">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-md-auto">
              <h2 class="text-center">{{ subCategory?.SubCategoryName }}</h2>
              <p class="lead text-center mb-4 moduleContainer" [class.show]="subCategory?.IsShowMore"
                [innerHTML]="categoryData?.SubCategories | filterVideoSubCategory: subCategory?.SubCategoryId">
              </p>
              <a role="button" class="btn-showcontent" (click)="changeContentVisibility(subCategory)">{{ subCategory?.IsShowMore ? 'Show less': 'Show
                More' }}</a>
            </div>
          </div>
          <div class="row align-items-end" *ngIf="AllVideoData != null && AllVideoData?.length > 0">
            <div class="col-sm-6 col-md-4 col-xl-3 col-12 row-seprator"
              *ngFor="let item of getVideoData(subCategory?.SubCategoryId)">
              <app-video-post [video]="item"></app-video-post>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
  <section class="block-1-Container" style="background: #ffffff">
    <div class="container-fluid">
      <h2 class="text-left">
        Tips to Make Your {{categoryHeadName}} Invitation Video Professional &amp; Formal
      </h2>
      <div class="my-4">
        <h4 class="content-title">Choose {{categoryHeadName}} Color Scheme</h4>
        <p class="content-info">
          Different templates and fonts that are offered by FlexClip have
          different colors. Choose the template that matches the theme of the
          {{categoryHeadName}} in general and your invite in particular. This will enhance your
          creativity and allow you to get an awesome {{categoryHeadName}} invite as an output.
        </p>
      </div>

      <div class="my-4">
        <h4 class="content-title">Attach All Relevant Information for {{categoryHeadName}}</h4>
        <p class="content-info">
          Make sure that you add the info that is required as mandatory. It
          includes the names of the hosts, time, venue, date and who will be your
          {{categoryHeadName}} host. The {{categoryHeadName}} templates that are available with the FlexClip
          have left enough spaces to add all the relevant information for your wed
          invite.
        </p>
      </div>
      <div class="my-4">
        <h4 class="content-title">Slideshow Your Love Story</h4>
        <p class="content-info">
          Your sweet love story is a must for a touching {{categoryHeadName}} invite. It?s
          wonderful &amp; easy to tell your story via a slideshow. In addition,
          pairing with a piece of romantic background music, your {{categoryHeadName}} invite
          will be one-of-the-kind.
        </p>
        <div class="block-video-item my-4">
          <iframe [src]="randomVideoLink" title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </section>
</div>